import React from 'react'
import SuperAgent from 'superagent'
import MarkDownHelper from './MarkDownHelper'
import { string, array } from 'prop-types'
const { settings: { docsAPIEndpointJSON, docsAPIEndpoint } } = require('../../../../../config/generatedConfig')

class DocWarrior extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      content: 'Loading content...'
    }
    this.parseDocs = this.parseDocs.bind(this)
  }

  shouldComponentUpdate (nextProps, nextState) {
    return this.checkUpdated(nextState.content, this.state.content)
  }

  checkUpdated (next, current) {
    if (typeof next === 'object') {
      return JSON.stringify(next) !== JSON.stringify(current)
    }
    return next !== current
  }

  makeRequestURL () {
    const { functionParams } = this.props
    const endpoint = functionParams[1] && functionParams[1] === 'json' ? docsAPIEndpointJSON : docsAPIEndpoint
    return endpoint + '&docs=' + functionParams[0] + '&noCache=1'
  }

  html (body) {
    if (!body.html) return false
    this.setState({
      content: body.html
    })
  }

  parseDocs (err, res) {
    const { functionParams } = this.props
    if (err || !res || !res.body) return false
    const specialMode = functionParams[2] ? functionParams[2] : false
    if (functionParams[1] && functionParams[1] === 'json') return this.parseMarkDown(res.body, specialMode)
    return this.html(res.body)
  }

  componentDidMount () {
    SuperAgent
      .get(this.makeRequestURL())
      .end(this.parseDocs)
  }

  parseMarkDown (body, specialMode) {
    if (!body.length) return
    let html = '<div class="mark-down">'
    body.map((section) => {
      section.map((item) => {
        html += MarkDownHelper.renderItem(item, specialMode)
      })
    })
    html += specialMode && specialMode === 'accordion' ? '</div></div></div>' : '</div>'
    this.setState({
      content: html
    })
  }

  render () {
    const { id } = this.props
    const { content } = this.state
    return (
      <div id={id} dangerouslySetInnerHTML={{ __html: content }} />
    )
  }
}

DocWarrior.propTypes = {
  id: string,
  functionParams: array
}

DocWarrior.defaultProps = {
  functionParams: []
}

export default DocWarrior



// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/markdown/DocWarrior.jsx